<template>
  <div>
    <div class="title mb-2">
      請告訴我這件商品是什麽？
    </div>

    <div class="mt-2">
      請輸入關鍵字選擇相似商品：
    </div>

    <div class="inputWrap mt-2">
      <div>
        <input
          v-model="searchKey"
          type="search"
          placeholder="請輸入商品關鍵詞 如衣服、褲子"
          @keyup.enter="onSearchKeyEnter"
        >
      </div>
      <div class="search-actions">
        <!-- 图片搜索按钮 -->
        <ImageSearchButton
          :parcel="parcel"
          @search-image="onImageSearchResults"
          @search-error="onImageSearchError"
        />
        <v-btn
          :loading="searchLoading"
          flat
          class="ma-0"
          @click="searchByKeyword()"
        >
          搜&nbsp;&nbsp;索
        </v-btn>
      </div>
    </div>

    <!-- 切换到图片搜索 -->
    <!-- <div class="text-center mt-4 mb-2">
      <v-btn
        flat
        color="primary"
        @click="$emit('change-input-type', 'imageSearch')"
      >
        <u>以圖識物</u>
      </v-btn>
    </div> -->

    <div
      v-if="shouldShowError"
      class="red--text mt-4"
    >
      {{ searchError }}
    </div>

    <v-divider class="my-4" />

    <div
      v-if="searchError"
      class="my-4 red--text"
    >
      {{ searchError }}
    </div>

    <div v-if="hasSearchResults">
      選擇一個最相似的商品：
      <v-layout
        wrap
        class="mt-2"
      >
        <template v-for="item in searchGoodsList">
          <v-flex
            v-if="!choseItemid || choseItemid === item.id"
            :key="item.id"
            xs4
            class="searchGoodsItem mb-2"
            @click="toggleItem(item)"
          >
            <div class="itemContent pb-2">
              <KImg
                :src="getItemImage(item)"
                replaceTbOrigin
                style="aspect-ratio: 3/4;object-fit: cover;"
              />
              <div
                class="line-clamp-2 caption mt-1"
                style="height: 3em;"
              >
                {{ getItemTitle(item) }}
              </div>
              <div class="choseBtn">
                <!-- 顯示加載狀態 -->
                <v-progress-circular
                  v-if="isItemDetailLoading(item)"
                  size="20"
                  width="2"
                  indeterminate
                  color="blue"
                />
                <!-- 顯示選中狀態 -->
                <template v-else>
                  <v-icon
                    v-if="isItemSelected(item)"
                    class="blue--text"
                  >
                    check_circle
                  </v-icon>
                  <v-icon v-else>
                    radio_button_unchecked
                  </v-icon>
                </template>
              </div>
            </div>
          </v-flex>
        </template>
      </v-layout>
    </div>

    <template v-if="choseItemid">
      <v-text-field
        :value="itemQty"
        :rules="[$store.state.validationRules.required]"
        label="商品數量"
        class="mt-3 pt-0"
        type="number"
        @input="$emit('update:itemQty', $event)"
      />
      <div class="title mt-2">
        如果需要，您可以順便寫下只有你自己看得到的備註
      </div>
      <v-text-field
        :value="memo"
        autofocus
        placeholder="非必填"
        class="mb-3 mt-0 pt-0"
        @input="$emit('update:memo', $event)"
      />
    </template>
  </div>
</template>

<script>
import ImageSearchButton from './ImageSearchButton.vue'
import productSearchMixin from '@g/mixins/productSearchMixin'

export default {
  components: {
    ImageSearchButton
  },
  mixins: [productSearchMixin],
  props: {
    parcel: {
      type: Object,
      default: null
    },
    itemQty: {
      type: String,
      default: '1'
    },
    memo: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      searchError: ''
    }
  },
  computed: {
    // 重寫 mixin 中的自定義過濾器
    customFilter () {
      return (item) => {
        // 過濾掉已存在於包裹中的商品
        if (this.parcel && this.parcel.extraInfo && this.parcel.extraInfo.tpTaobaoTradeItems) {
          const itemid = item.itemid || item.id
          return this.parcel.extraInfo.tpTaobaoTradeItems.find(i => i.itemid === itemid) === undefined
        }
        return true
      }
    }
  },
  methods: {
    // 重寫 mixin 中的 toggleItem 方法，添加事件發送
    async toggleItem (item) {
      this.searchError = ''
      // 調用 mixin 中的方法
      await this.$options.mixins[0].methods.toggleItem.call(this, item)
      if (!this.choseItem.itemCid) {
        this.searchError = '該商品無法查詢，請更換商品試試'
        this.choseItem = null
        return
      }
      // 發送事件到父組件
      this.$emit('item-changed', this.choseItem)
    },

    // 處理圖片搜索結果 - 使用統一的搜索服務
    async onImageSearchResults (imageBase64) {
      await this.searchByImage(imageBase64)
    },

    // 處理圖片搜索錯誤
    onImageSearchError (errorMsg) {
      this.searchError = errorMsg
    }
  }
}
</script>

<style lang="postcss" scoped>
.inputWrap {
  border: 2px solid #ff7200;
  border-radius: 50px;
  display: flex;
  > :nth-child(1) {
    flex: 1;
    input {
      display: block;
      width: 100%;
      height: 48px;
      padding: 5px 20px;
      font-size: 14px;
      border: 0;
      background: #fff;
      outline: none;
      border-radius: 50px;
    }
  }
  > :nth-child(2) {
    &.search-actions {
      display: flex;
      align-items: center;
      gap: 8px;
    }

    button {
      display: block;
      height: 100%;
      background: #f27b03;
      font-size: 16px;
      color: #fff;
      border: none;
      padding: 0 30px;
      outline: none;
      border-radius: 50px;
    }
  }
}

.searchGoodsItem {
  padding: 10px;
  cursor: pointer;
  img {
    width: 100%;
  }
  .itemContent {
    border: 1px dashed rgba(0,0,0,0.2);
    border-radius: 5px;
    padding: 3px;
    position: relative;
    .choseBtn {
      position: absolute;
      left: 0px;
      top: 0px;
      background: #fff;
    }
  }
}
</style>
